// Libraries
var React = require('react');
var dateFormat = require('dateformat');
var hdate = require('human-date');

// Styles
require('../Hero.scss');
require('./MainHero.scss');

// Assets
var videoSvg = require('./Play.svg');
var audioSvg = require('./Audio.svg');
var authorSvg = require('./Author.svg');
var clockSvg = require('./Clock.svg');
var xSvg = require('./x.svg');

// Components
var VideoEmbed = require('../../Video/VideoEmbed');
var VideoModal = require('../../Video/VideoModal');
var CallToAction = require('CallToAction/CallToAction');
var DialogButton = require('../../Dialog/DialogButton');
var { getLoginStatus } = require('Logon/Logon');

// TODO:
// 1. make the hero's background image responsive with the difference sizes from json file

class MainHeroModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			videoPlaying: !!this.props.data.isAutoplay,
			isModalOpen: !!this.props.data.isAutoplay,
			isLoggedIn: false
		};

	}

	componentDidMount() {
		getLoginStatus()
			.then(result => {
				this.setState({ isLoggedIn: result.isLoggedIn });
			})
			.catch(err => {
				console.error('Login status fetch failed:', err);
			});
	}

	playVideoModal = () => {
		this.setState({...this.state, videoPlaying: true, isModalOpen: true});
	};

	onCloseModal = () => {
		this.setState({...this.state, videoPlaying: true, isModalOpen: false});
	};

	createTitle = () => {
		return {__html: this.props.data.title};
	}

	getLinkOrButton = (accessibleText, icon, linkText) => {

		const renderDialog = this.props.data.media.membershipTier === 'Member' && !this.state.isLoggedIn;
		const dialogName = 'dialog-video-member-modal';
		let dialogText = 'Sign up or sign in to ';
		dialogText = this.props.data.media.type === "AUDIO" ? dialogText + 'listen' : dialogText + 'watch this video';

		const appDeeplink = 'yc-fa-tot://action/MEDIA_ITEM?id=GUID_' + this.props.data.media.entryId;

		if (
			this.props.data.media.isAppLink !== undefined &&
			this.props.data.media.isAppLink
		) {

			return (
				<a href={appDeeplink} rel="noreferrer noopener" target="_blank" aria-label={"Open " + accessibleText}>
					{icon}
					<span>{linkText}</span>
				</a>
			)

		}

		if (renderDialog) {

			return(
				<DialogButton name={dialogName}>
					{icon}
					<span>{linkText}</span>
					<span className="u-visually-hidden">({dialogText})</span>
				</DialogButton>
			)

		}

		if (this.props.data.media.externalLink) {

			return(
				<a href={this.props.data.media.externalLink} rel="noreferrer noopener" target="_blank" aria-label={"Open " + accessibleText}>
					{icon}
					<span>{linkText}</span>
				</a>
			)

		}

		return (
			<button onClick={this.playVideoModal} aria-label={'Play ' + accessibleText}>
				{icon}
				<span>{linkText}</span>
			</button>
		)

	}

	render() {
		if (this.props.data.disableHeroBanner){
			return (<div></div>);
		}

		const image = this.props.data.image;
		const mediaIcon = this.props.data.media ? <img src={this.props.data.media.type === "AUDIO" ? audioSvg : videoSvg } alt="" /> : '';
		const mediaAccessibleText = this.props.data.media ? (this.props.data.media.caption + ' (' + this.props.data.media.type.toLowerCase() + ')') : '';
		const mediaLinkText = this.props.data.media ? (!this.props.data.mediaLinkText || this.props.data.mediaLinkText.length===0? (this.props.data.media.type === "AUDIO" ? "Play audio" : "Play video"):this.props.data.mediaLinkText) : '';
		const title = <h1 dangerouslySetInnerHTML={this.createTitle()} className={this.props.data.size ? this.props.data.size : "large"}></h1>

		return (
			<div className="MainHero" id={this.props.data.id}>
				<div className="MainHero__headingContainer">
					<div className="MainHero__heading--background preview" style={{backgroundImage: `url(${image.previewUrl})`, filter: 'blur(20px)'}}>
					</div>
					<div ref={(heroHeading) => { this.heroHeading = heroHeading; }} className="MainHero__heading--background">
						<picture>
							<source srcset={image.extraLargeUrl} media="(min-width: 1400px)" />
							<source srcset={image.largeUrl} media="(min-width: 1024px)" />
							<source srcset={image.mediumUrl} media="(min-width: 750px)" />
							<img src={image.smallUrl} alt="" />
						</picture>
					</div>
				</div>
				{this.props.data.backgroundVideo && this.props.data.backgroundVideo.length > 0 &&
				<div className="MainHero__video">
					<video className="lazy" autoPlay muted loop playsInline >
						{this.props.data.backgroundVideo.map(v => (
							<source key={v.type} data-src={v.src} type={v.type} />
						))}
					</video>
				</div>
				}
				<div className={"MainHero__heading wrapper" + (this.props.data.publishDate && this.props.data.author ? " tall" : "")}>
					<p className="tags">
						{this.props.data.tags && this.props.data.tags.map((tag, index) => {
							return(<a href={tag.url} rel="nofollow" key={index}>{tag.hashtag} </a>);
						})}
					</p>

					{this.props.data.link ? (
						<a href={this.props.data.link.url}>{title}</a>
					) : title}

					{this.props.data.subTitle &&
					<p className="subtitle">
						{this.props.data.link ? (
							<a href={this.props.data.link.url}>{this.props.data.subTitle}</a>
						) : this.props.data.subTitle}
					</p>
					}

					{this.props.data.media &&
						<div className="media">
							{this.getLinkOrButton(mediaAccessibleText, mediaIcon, mediaLinkText)}
						</div>
					}

					{this.props.data.link &&
						<div>
							<a href={this.props.data.link.url} className="c-button c-button--on-dark">{this.props.data.link.caption}</a>
						</div>
						// <CallToAction {...this.props.data.link} />
					}
				</div>

				{this.props.data.publishDate && this.props.data.author &&
				<div className="MainHero__article-details">
					{this.props.data.twitter && <p>
						<img src={xSvg} alt="" className="inline-icon inline-icon--x"/>
							<a href={this.props.data.twitter.url} target="_blank" className='twitter-link' rel="noopener noreferrer">{this.props.data.twitter.label}</a>
					</p>}
					<p>
						<img src={clockSvg} alt="" className="inline-icon"/>
						{dateFormat(hdate.toUTC(this.props.data.publishDate), "ddd dd mmmm yyyy, HH:MM")}
						<span className="separator">|</span>
						<img src={authorSvg} alt="" className="inline-icon"/>
						{this.props.data.author}
					</p>
				</div>
				}

				{this.props.data.media &&
				<div>
					<VideoModal isOpen={this.state.isModalOpen} onCancel={this.onCloseModal}>
						<VideoEmbed type="STREAM" data={this.props.data.media} autoplay />
					</VideoModal>
				</div>
				}

			</div>
		)
	}
}

module.exports = MainHeroModule;



// WEBPACK FOOTER //
// ./src/components/Hero/MainHero/MainHeroModule.js